import { useState } from "react";
import { CheckCircle, CaretDown, CaretUp, User } from "@phosphor-icons/react";
import { SourcePill, daysSince } from "./TicketCard";

const PREVIEW = 8;

// Franja "Listos · alta": separada del tablero para que no se pierda. También
// es zona de drop: soltar una tarjeta aquí abre el diálogo de alta/entrega.
export default function ReadyStrip({ tickets, onOpen, isOver, dropHandlers }) {
  const [all, setAll] = useState(false);
  const sorted = [...tickets].sort((a, b) => new Date(b.closed_at || b.updated_at || 0) - new Date(a.closed_at || a.updated_at || 0));
  const shown = all ? sorted : sorted.slice(0, PREVIEW);
  return (
    <section
      {...dropHandlers}
      className={`rounded-lg border-2 transition-colors ${isOver ? "border-emerald-500 bg-emerald-50" : "border-emerald-200 bg-emerald-50/40"}`}
      data-testid="ready-strip"
    >
      <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-emerald-200/70">
        <div className="flex items-center gap-2 min-w-0">
          <CheckCircle size={16} weight="fill" className="text-[#00873D] shrink-0" />
          <span className="font-heading font-bold text-sm uppercase tracking-wider text-[#00873D]">Listos · alta</span>
          <span className="text-xs font-mono-data text-emerald-800/70" data-testid="ready-count">{tickets.length}</span>
          <span className="hidden sm:inline text-[11px] text-emerald-900/60 truncate">· {isOver ? "Suelta aquí para dar de alta" : "Arrastra un equipo aquí para darlo de alta o entregarlo"}</span>
        </div>
        {tickets.length > PREVIEW && (
          <button type="button" onClick={() => setAll((v) => !v)} className="text-[11px] font-semibold text-[#00873D] inline-flex items-center gap-1 hover:underline shrink-0" data-testid="ready-toggle">
            {all ? <><CaretUp size={11} weight="bold" /> Ver menos</> : <><CaretDown size={11} weight="bold" /> Ver todos ({tickets.length})</>}
          </button>
        )}
      </div>
      {tickets.length === 0 ? (
        <div className="px-4 py-5 text-center text-xs text-emerald-900/50 italic" data-testid="ready-empty">Aún no hay equipos dados de alta.</div>
      ) : (
        <ul className={`p-3 gap-2 ${all ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4" : "flex overflow-x-auto [&>*]:shrink-0 [&>*]:w-[230px]"}`} data-testid="ready-list">
          {shown.map((t) => {
            const d = daysSince(t.closed_at || t.updated_at);
            return (
              <li key={t.id}>
                <button type="button" onClick={() => onOpen(t)} className="w-full text-left bg-white border border-emerald-200 rounded-md px-3 py-2 hover:border-[#00873D] hover:shadow-sm transition-[border-color,box-shadow]" data-testid={`ready-card-${t.id}`}>
                  <div className="flex items-center justify-between gap-2">
                    <SourcePill source={t.source} size="xs" />
                    <span className="text-[10px] font-mono-data text-zinc-400 shrink-0">{d === 0 ? "hoy" : `hace ${d}d`}</span>
                  </div>
                  <div className="font-semibold text-xs text-zinc-900 mt-1 truncate" title={t.product_name}>{t.product_name}</div>
                  <div className="text-[10px] text-zinc-500 mt-0.5 inline-flex items-center gap-1 truncate"><User size={10} /> {t.technician_name || "Sin técnico"}</div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
